import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getMessaging } from 'firebase/messaging';

// Firebase configuration - uses environment variables with fallbacks
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDMuFVGWFZRhPJ9obORk6Tr86DeX9z0bgw",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "pokebase-485005.firebaseapp.com",
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || "https://pokebase-485005-default-rtdb.firebaseio.com/",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "pokebase-485005",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "pokebase-485005.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "24343609456",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:24343609456:web:ceebede6664b82447674b5",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-VFJ3W17EF4"
};

// Validate config
const isValidConfig = firebaseConfig.apiKey && firebaseConfig.projectId;

// Initialize Firebase with safety fallback
let app = null;
let db = null;
let auth = null;
let analytics = null;
let perf = null;
let rtdb = null;
let storage = null;
let messaging = null;

if (isValidConfig) {
  try {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    auth = getAuth(app);
    analytics = getAnalytics(app);
    perf = getPerformance(app);
    rtdb = getDatabase(app);
    storage = getStorage(app);
    messaging = getMessaging(app);
    console.log('[Firebase] Initialized successfully');
  } catch (error) {
    console.warn("[Firebase] Initialization Failed: App running in offline stateless mode.", error);
  }
} else {
  console.warn("[Firebase] Invalid configuration: App running in offline stateless mode.");
}

// Export services (they might be null if initialization failed)
export { db, auth, analytics, perf, rtdb, storage, messaging };
export default app;
